import { computed } from 'vue'
import { defineStore } from 'pinia'
import { makeId } from '../../lib/lib'
import constants from '../../lib/constants'
import axios from 'axios'
import { useVuelidate } from '@vuelidate/core'
import {
  email,
  helpers,
  maxLength,
  minLength,
  required,
} from '@vuelidate/validators'
import * as lib from './../../lib/lib'
const { telephone, greekLatinSpace } = constants.regex

export const useBookingStore = defineStore('bookingStore', {
  state: () => ({
    allFilters: {},
    movies: {},
    configuration: {},
    // dictionary:{},
    bookingProgress: {
      usersessionId: null,
      step: 0,
      totalWizardSteps: 5,
      selectedMovie: null,
      selectedCinema: {},
      selectedDay: null,
      selectedRoom: {},
      wizardStep: 0,
      selectedTickets: {},
      userVouchersCodes: [],
      selectedSeats: [],
      userShopItems: {
        // price: 0,
        // count: 0,
        // name: product.name
      },
      // or propmocode
      voucherType: constants.noVoucherType,
      paymentDetails: {
        firstName: null,
        lastName: null,
        email: null,
        mobilePhone: null,
        terms: false,
        registerContest: false,
        invalid: true,
        familyClubMember: false,
      },
      concessionsAllowed: true,
      contestId: '',
      contestText: '',
    },
    cinemaScreens: [],
    tickets: [],
    CD4UTickets: [],
    userVouchersCodesModal: [],
    seatsPlan: null,
    seatsSpecial: [],
    creditVoucher: null,
    accountData: null,
    amount: 0,
    errorMsgs: [],
    shopItems: [],
    selectedFilters: {},
    points: 0,
    userPoints: 0,
    interestFormData: null,
    otpFormData: null,
  }),
  getters: {
    activeWizardStep(state) {
      return state.bookingProgress.wizardStep
    },
    userIsLoggedIn: (state) => {
      return state.accountData.memberId
    },

    accountIsInValidForPayment: (state) => {
      const rules = computed(() => ({
        memberId: {
          required,
        },
        firstName: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(40),
          regex: helpers.regex(greekLatinSpace),
        },
        lastName: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(40),
          regex: helpers.regex(greekLatinSpace),
        },
        email: {
          required,
          email,
        },
        mobilePhone: {
          required,
          regex: helpers.regex(telephone),
        },
      }))

      const v$ = useVuelidate(rules, state.accountData)
      return v$.value.$invalid
    },

    getAllCinemas: (state) => {
      return state.allFilters.cinemas
    },
    getSelectedTicketsCounter: (state) => {
      return (ticket) => {
        return (
          state.bookingProgress.selectedTickets[ticket.ticketId]?.count || 0
        )
      }
    },
    getVoucherType: (state) => {
      return state.bookingProgress.voucherType
    },
    getAllTickets: (state) => {
      return state.tickets
    },
    getAllSelectedTickets: (state) => {
      return state.bookingProgress.selectedTickets
    },
    getTotalSelectedTickets: (state) => {
      return (
        Object.keys(state.bookingProgress.selectedTickets).length &&
        Object.values(state.bookingProgress.selectedTickets).reduce(
          (ticket, currentValue) => {
            return currentValue.ticketPrice * currentValue.count + ticket
          },
          0
        )
      )
    },

    // POINTS

    getUserPoints: (state) => {
      return state.accountData ? state.accountData.points : 0
    },

    getTicketsPoints: (state) => {
      return (
        Object.keys(state.bookingProgress.selectedTickets).length &&
        Object.values(state.bookingProgress.selectedTickets).reduce(
          (ticket, currentValue) => {
            return currentValue.points * currentValue.count + ticket
          },
          0
        )
      )
    },

    getProductsPoints: (state) => {
      return (
        Object.keys(state.bookingProgress.userShopItems).length &&
        Object.values(state.bookingProgress.userShopItems).reduce(
          (product, currentValue) => {
            return currentValue.points * currentValue.count + product
          },
          0
        )
      )
    },

    getTotalUsedPoints() {
      return this.getTicketsPoints + this.getProductsPoints
    },

    getRemainPoints() {
      return this.getUserPoints - this.getTicketsPoints - this.getProductsPoints
    },

    showPointsBox(state) {
      return state.accountData &&
        state.accountData.clubId &&
        state.accountData.allowPoints
        ? true
        : false
    },

    getTotalCart() {
      // TODO: review credit note logic
      const voucherAmount = this.creditVoucher
        ? this.creditVoucher.discountAmount
        : 0
      const totalCart =
        this.getTotalSelectedProducts +
        this.getTotalSelectedTickets +
        this.getUserVouchersTotalPrice
      const totalAfterDedication =
        voucherAmount >= totalCart
          ? totalCart - totalCart
          : totalCart - voucherAmount
      return totalAfterDedication
    },

    getSelectedTicketsCount: (state) => {
      return (
        Object.keys(state.bookingProgress.selectedTickets).length &&
        Object.values(state.bookingProgress.selectedTickets).reduce(
          (ticket, currentValue) => {
            return currentValue.count + ticket
          },
          0
        )
      )
    },
    getSeatsCount: (state) => {
      const { selectedTickets, userVouchersCodes } = state.bookingProgress

      return (
        Object.keys(selectedTickets).length &&
        Object.values(selectedTickets).reduce(
          (accumulator, currentValue) => currentValue.seatsCount + accumulator,
          0
        ) + userVouchersCodes.length
      )
    },
    getTicketInfo: (state) => {
      return (ticketId) => {
        return state.tickets.find((ticket) => ticket.id === ticketId)
      }
    },
    getSelectedTicket: (state) => {
      return (id) => {
        return state.bookingProgress.selectedTickets[id]
      }
    },

    getUserVouchersCodesModal: (state) => {
      return state.userVouchersCodesModal
    },

    getSelectedSeats: (state) => {
      return state.bookingProgress.selectedSeats
    },

    getSelectedProductCounter: (state) => {
      return (product) => {
        const productSelected = Object.prototype.hasOwnProperty.call(
          state.bookingProgress.userShopItems,
          product.id
        )
        return productSelected
          ? state.bookingProgress.userShopItems[product.id].count
          : 0
      }
    },

    getTotalSelectedProducts: (state) => {
      return (
        Object.keys(state.bookingProgress.userShopItems).length &&
        Object.values(state.bookingProgress.userShopItems).reduce(
          (product, currentValue) => {
            return currentValue.price * currentValue.count + product
          },
          0
        )
      )
    },
    getSelectedProductsCount: (state) => {
      return (
        Object.keys(state.bookingProgress.userShopItems).length &&
        Object.values(state.bookingProgress.userShopItems).reduce(
          (product, currentValue) => {
            return currentValue.count + product
          },
          0
        )
      )
    },
    getAllSelectedProducts: (state) => {
      return state.bookingProgress.userShopItems
    },
    getAllCinemaScreens: (state) => {
      return state.cinemaScreens
    },
    getCD4UTickets: (state) => {
      return state.CD4UTickets
    },

    getUserVouchersCodes: (state) => {
      return state.bookingProgress.userVouchersCodes
    },
    getUserVouchersTotalPrice: (state) => {
      return state.bookingProgress.userVouchersCodes
        .map((i) => i.amount || 0)
        .reduce((a, b) => a + b, 0)
    },
    getSeatsPlan: (state) => {
      return state.seatsPlan
    },
    getReachedMaximumTotalTickets() {
      const sum =
        this.getSelectedTicketsCount +
        this.bookingProgress.userVouchersCodes.length

      return sum === this.configuration?.maximumTickets
    },

    getRoomType: (state) => {
      return (screen) => {
        return state.allFilters.roomTypes
          .filter((sc) => screen.roomTypes.includes(sc.value))
          .map((item) => item.display)
          .join(' ')
      }
    },
    getSelectedCinema: (state) => {
      return state.bookingProgress.selectedCinema
    },
    getSelectedFilters: (state) => {
      return state.selectedFilters
    },

    getConcessionsAllowed: (state) => {
      return state.bookingProgress.concessionsAllowed
    },

    getAccountData: (state) => {
      return state.accountData
    },
    getContestText: (state) => {
      return state.bookingProgress.contestText
    },
    getSeatsRemainingAllocate: (state) => {
      if (!state.seatsPlan) {
        return state.bookingProgress.selectedTickets.length
      }

      const { areaCategories } = state.seatsPlan

      const seatsToAllocate = areaCategories.reduce((s, f) => {
        return s + f.seatsToAllocate
      }, 0)

      const seatsAllocatedCount = areaCategories.reduce((s, f) => {
        return s + f.seatsAllocatedCount
      }, 0)

      return seatsToAllocate - seatsAllocatedCount
    },

    hasSeatsRemainingAllocate: (state) => {
      return state.getSeatsRemainingAllocate > 0
    },
  },
  actions: {
    resetAll() {
      this.bookingProgress.step = 0
      this.bookingProgress.selectedMovie = null
      this.bookingProgress.selectedCinema = {}
      this.bookingProgress.selectedDay = null
      this.bookingProgress.selectedRoom = null
      this.bookingProgress.userVouchersCodes = []
      this.bookingProgress.selectedTickets = {}
    },
    selectMovie(movie) {
      this.bookingProgress.selectedMovie = movie
      this.bookingProgress.step = 1
      this.bookingProgress.selectedCinema = {}
      this.bookingProgress.selectedDay = null
      this.bookingProgress.selectedRoom = {}
      this.bookingProgress.userVouchersCodes = []
      this.bookingProgress.selectedTickets = {}
    },
    selectCinema(cinema) {
      this.bookingProgress.selectedCinema = cinema
      this.bookingProgress.step = 2
      this.bookingProgress.selectedDay = null
      this.bookingProgress.selectedRoom = {}
      this.bookingProgress.userVouchersCodes = []
      this.bookingProgress.selectedTickets = {}
    },
    selectDate(date) {
      this.bookingProgress.selectedDay = date
      this.bookingProgress.step = 3
      this.bookingProgress.selectedRoom = {}
      this.bookingProgress.userVouchersCodes = []
      this.bookingProgress.selectedTickets = {}
      // call room types by date, cinemaId, movieId
      this.cinemaScreens = this.allFilters.screens.filter((screen) => {
        const cinemaMatch =
          screen.cinemaId === this.bookingProgress.selectedCinema.value
        const movieMatch =
          screen.scheduledFilmId === this.bookingProgress.selectedMovie.movieId
        const sessionDatePart = screen.sessionBusinessDate.split('T')[0]
        const dateMatch =
          this.bookingProgress.selectedDay &&
          sessionDatePart === this.bookingProgress.selectedDay.dateValue
        return cinemaMatch && movieMatch && dateMatch
      })
    },
    async selectRoom(room) {
      // call tickets by cinemaId, movieId, screenId
      this.bookingProgress.selectedRoom = room
      this.bookingProgress.step = 4
    },
    updateBookingWizard(step) {
      this.bookingProgress.wizardStep = step
    },
    addTicket(ticket) {
      const ticketExist = this.checkTicketExist(ticket)
      if (!ticketExist) {
        this.bookingProgress.selectedTickets[ticket.ticketId] = {
          ticketPrice: ticket.ticketPrice,
          count: 0,
          seatsCount: 0,
          ticketDescription: ticket.ticketDescription,
          points: ticket.points,
          offerId: ticket.offerId || 0,
          codes: [],
        }
      }
      this.bookingProgress.selectedTickets[ticket.ticketId] = {
        ...this.bookingProgress.selectedTickets[ticket.ticketId],
        count: this.bookingProgress.selectedTickets[ticket.ticketId].count + 1,
        seatsCount:
          this.bookingProgress.selectedTickets[ticket.ticketId].seatsCount +
          ticket.seatsCount,
        codes: this.bookingProgress.selectedTickets[
          ticket.ticketId
        ].codes.concat((ticket.code && [ticket.code]) || []),
      }
    },
    removeTicket(ticket) {
      this.bookingProgress.selectedTickets[ticket.ticketId] = {
        ...this.bookingProgress.selectedTickets[ticket.ticketId],
        count: this.bookingProgress.selectedTickets[ticket.ticketId].count - 1,
        seatsCount:
          this.bookingProgress.selectedTickets[ticket.ticketId].seatsCount -
          ticket.seatsCount,
        codes: this.bookingProgress.selectedTickets[
          ticket.ticketId
        ].codes.slice(0, -1),
      }
      if (this.bookingProgress.selectedTickets[ticket.ticketId].count === 0) {
        delete this.bookingProgress.selectedTickets[ticket.ticketId]
      }
    },

    hardRemoveTicket(ticket) {
      delete this.bookingProgress.selectedTickets[ticket.ticketId]
    },

    checkTicketExist(ticket) {
      return Object.prototype.hasOwnProperty.call(
        this.bookingProgress.selectedTickets,
        ticket.ticketId
      )
    },

    checkAvailablePoints(itemPoints) {
      if (itemPoints === null || itemPoints === undefined) {
        return true
      }

      return this.getRemainPoints >= itemPoints
    },

    // concatPointsLabel(itemPoints) {
    //   if (itemPoints > 0) {
    //     return   this.dictionary.pointsLabel.replace('{x}', itemPoints)
    //   }
    // },

    addUserVoucher() {
      console.log('voucher', this.userVouchersCodesModal.length)
      if (this.userVouchersCodesModal.length < 8) {
        console.log('if')
        const voucherId = `voucher - ${makeId(5)}`
        this.userVouchersCodesModal.push({
          id: voucherId,
          code: '',
          valid: true,
          message: '',
          ticketPrice: 0,
          active: true,
          type: '2',
        })
      }
    },

    popVoucherModal() {
      this.userVouchersCodesModal.pop()
    },

    popUserVoucher() {
      this.bookingProgress.userVouchersCodes.pop()
    },

    removeVoucherCodeByIndex(code) {
      const objWithIdIndex = this.bookingProgress.userVouchersCodes.findIndex(
        (obj) => obj.id === code.id
      )
      this.bookingProgress.userVouchersCodes.splice(objWithIdIndex, 1)
    },

    removeUserVoucherCodeModalByIndex(index) {
      this.userVouchersCodesModal.splice(index, 1)
    },

    removeSelectedSeat(seat) {
      const index = this.bookingProgress.selectedSeats.indexOf(seat, 0)
      if (index > -1) {
        this.bookingProgress.selectedSeats.splice(index, 1)
      }
    },

    assignDomData(domData) {
      this.allFilters = {
        ...domData?.filters,
        screens: [].concat(domData?.screens),
      }
      this.movies = domData?.records
      this.configuration = domData?.configuration
      //  this.dictionary = domData?.dictionary
    },

    addNewUserProduct(product) {
      const ticketExist = Object.prototype.hasOwnProperty.call(
        this.bookingProgress.userShopItems,
        product.id
      )
      if (!ticketExist) {
        this.bookingProgress.userShopItems[product.id] = {
          price: product.price,
          count: 0,
          name: product.name,
          points: product.points,
          recognitionId: product.recognitionId,
        }
      }
      this.bookingProgress.userShopItems[product.id] = {
        ...this.bookingProgress.userShopItems[product.id],
        count: this.bookingProgress.userShopItems[product.id].count + 1,
      }
    },
    removeUserProduct(product) {
      this.bookingProgress.userShopItems[product.id] = {
        ...this.bookingProgress.userShopItems[product.id],
        count: this.bookingProgress.userShopItems[product.id].count - 1,
      }
      if (this.bookingProgress.userShopItems[product.id].count === 0) {
        delete this.bookingProgress.userShopItems[product.id]
      }
    },

    clearUserProducts() {
      this.bookingProgress.userShopItems = {}
    },

    setTickets(ticketTypes, vouchers, concessionsAllowed) {
      this.tickets = ticketTypes
      this.CD4UTickets = vouchers
      this.bookingProgress.concessionsAllowed =
        this.bookingProgress.concessionsAllowed && concessionsAllowed
    },

    resetVoucherCodes() {
      this.bookingProgress.userVouchersCodes = []
    },

    assignPrepaidVoucherCodes(validationResults, voucherInOrderMessage) {
      for (const voucher of this.getUserVouchersCodesModal) {
        const validationResult = validationResults.find(
          (v) => v.code === voucher.code
        )
        if (validationResult) {
          voucher.valid = validationResult.valid
          voucher.message = validationResult.message
        }
        if (
          this.bookingProgress.userVouchersCodes.some(
            (v) => v.code === voucher.code
          )
        ) {
          voucher.valid = false
          voucher.message = voucherInOrderMessage
        }
      }
      if (this.getUserVouchersCodesModal.every((i) => i.valid)) {
        this.bookingProgress.voucherType = constants.prepaidVoucherType
        this.tickets = []
        this.CD4UTickets = []
        this.bookingProgress.concessionsAllowed = false
        Object.keys(this.bookingProgress.selectedTickets).forEach((key) => {
          delete this.bookingProgress.selectedTickets[key]
        })
        // check if dicount vouchers have been already applied
        // if so, remove them
        const { length } = constants.vouchers.discount
        const hasDiscountVouchers = this.bookingProgress.userVouchersCodes.some(
          (i) => i.code.length === length
        )
        if (hasDiscountVouchers) {
          this.bookingProgress.userVouchersCodes = []
        }
        this.bookingProgress.userVouchersCodes = [
          ...this.bookingProgress.userVouchersCodes,
          ...this.getUserVouchersCodesModal,
        ]
        this.userVouchersCodesModal = []
      }
    },
    assignDiscountVoucherCodes(validationResults, voucherInOrderMessage) {
      for (const voucher of this.getUserVouchersCodesModal) {
        const validationResult = validationResults.find(
          (v) => v.code === voucher.code
        )
        if (validationResult) {
          voucher.valid = validationResult.valid
          voucher.message = validationResult.message
          voucher.amount = validationResult.amount
        }
        if (
          this.bookingProgress.userVouchersCodes.some(
            (v) => v.code === voucher.code
          )
        ) {
          voucher.valid = false
          voucher.message = voucherInOrderMessage
        }
      }
      if (this.getUserVouchersCodesModal.every((i) => i.valid)) {
        this.bookingProgress.voucherType = constants.discountVoucherType
        this.bookingProgress.userVouchersCodes = [
          ...this.bookingProgress.userVouchersCodes,
          ...this.getUserVouchersCodesModal,
        ]
        this.userVouchersCodesModal = []
      }
    },

    resetAllTicketsVouchers() {
      this.resetVoucherCodes()
      this.bookingProgress.voucherType = constants.noVoucherType
      this.userVouchersCodesModal = []
    },

    resetVoucherType() {
      this.bookingProgress.voucherType = constants.noVoucherType
    },

    async getAllSeatsPlanToRender() {
      await axios
        .post(
          this.configuration['seatsPlan'],
          {
            sessionId: this.bookingProgress.selectedRoom?.id,
            cinemaId: this.bookingProgress.selectedCinema?.value,
            userSessionId: this.bookingProgress.usersessionId,
          },
          lib.axiosConfig
        )
        .then((resp) => {
          if (resp.data.errorMessages.length || resp.data.hasError) {
            throw resp.data.errorMessages
          } else {
            this.seatsPlan = resp.data?.data.seatPlan
            this.allocateSelectedSeatsFromPlan()
            this.setSpecialSeats()
          }
        })
        .catch((error) => {
          throw error
        })
    },
    async chooseSeatHandler(seat) {
      await axios
        .post(
          this.configuration['chooseSeat'],
          {
            sessionId: this.bookingProgress.selectedRoom?.id,
            cinemaId: this.bookingProgress.selectedCinema?.value,
            row: seat.rowIndex,
            column: seat.columnIndex,
            userSessionId: this.bookingProgress.usersessionId,
          },
          lib.axiosConfig
        )
        .then((resp) => {
          if (resp.data.errorMessages.length || resp.data.hasError) {
            throw resp.data.errorMessages
          } else {
            this.seatsPlan = resp.data?.data.seatPlan
            this.allocateSelectedSeatsFromPlan()
          }
        })
        .catch((error) => {
          throw error
        })
    },
    allocateSelectedSeatsFromPlan() {
      this.bookingProgress.selectedSeats.splice(0)
      this.seatsPlan.rows.forEach((row) => {
        row.seats.forEach((column) => {
          if (column.status === 4) {
            this.bookingProgress.selectedSeats.push({
              ...column,
              physicalName: row.physicalName,
            })
          }
        })
      })
    },
    assignCreditVoucher(voucherData) {
      this.creditVoucher = voucherData
    },

    setSpecialSeats() {
      this.seatsSpecial = this.seatsPlan.rows
        .map((i) => i.seats)
        .flat()
        .filter((i) => i.status === 3)
        .map((x) => `${x.physicalName}${x.id}`)
    },
    removeCreditVoucher() {
      this.creditVoucher = null
    },

    setAccountData(payload) {
      this.accountData = payload
    },

    setPaymentDetails(payload) {
      if (payload) {
        for (const [key, value] of Object.entries(payload)) {
          this.bookingProgress.paymentDetails[key] = value
        }
      }
    },

    setPaymentField(payload) {
      this.bookingProgress.paymentDetails[payload.field] = payload.value
    },

    selectCinemaInCafe(cinema) {
      this.bookingProgress.selectedCinema = cinema
    },

    removeCinema() {
      this.bookingProgress.selectedCinema = {}
    },

    assignGlobalErrorMessages(messages) {
      this.errorMsgs = messages
    },

    setShopItems(data) {
      this.shopItems = []

      data.forEach((i) => {
        this.shopItems.push(i)
      })
    },

    setContestData(data) {
      this.bookingProgress.contestId = data.contestId
      this.bookingProgress.contestText = data.contestText
    },

    setShopItemsByCinema() {
      if (!this.bookingProgress.selectedCinema?.value) {
        return false
      }

      const entries = this.shopItems
      this.shopItems = []

      entries.forEach((category, index) => {
        this.shopItems.push({
          ...category,
          values: [],
        })
        category.values.forEach((item) => {
          if (
            item.cinemaId.toString() ===
            this.bookingProgress.selectedCinema.value
          ) {
            this.shopItems[index].values.push(item)
          }
        })
        if (this.shopItems[index].values.length === 0) {
          this.shopItems.splice(index, 1)
        }
      })
    },

    setSelectedFilters(payload) {
      this.selectedFilters = payload
    },

    resetUserVouchersCodesModal() {
      this.userVouchersCodesModal = []
    },

    setUsersessionId(payload) {
      this.bookingProgress.usersessionId = payload
    },

    setInterestFormData(payload) {
      this.interestFormData = payload
    },

    setOTPFormData(payload) {
      this.otpFormData = payload
    },

    printStore() {
      console.log('bookingProgress', this.bookingProgress)
      console.log('userVouchersCodesModal', this.userVouchersCodesModal)
    },
  },
})
